import React, { useEffect, useState } from "react";
import { adminApi, getAdminOrgId, setAdminOrgId } from "@/api/adminOneClient";

export default function OrgSelector() {
  const [orgs, setOrgs] = useState([]);
  const [active, setActive] = useState(getAdminOrgId() || "");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    adminApi.orgs(50).then(({ data }) => setOrgs(data?.orgs || [])).catch(() => {});
  }, []);

  const choose = (orgId) => {
    setAdminOrgId(orgId || null);
    setActive(orgId || "");
    setOpen(false);
    // hard reload so all subsequent requests carry the new X-Org-Id
    window.location.reload();
  };

  const label = active ? (orgs.find((o) => (o.id || o._id) === active)?.name || active.slice(0, 8)) : "GLOBAL";

  return (
    <span className="admin-orgsel" data-testid="admin-orgsel">
      <button type="button"
              className="admin-orgsel__btn"
              onClick={() => setOpen((v) => !v)}
              aria-expanded={open}
              data-testid="admin-orgsel-btn"
              title="Active organization (X-Org-Id header)">
        <span aria-hidden="true">▤</span>
        <span className="admin-orgsel__lbl">{label}</span>
      </button>
      {open && (
        <div className="admin-orgsel__menu" role="menu" data-testid="admin-orgsel-menu">
          <button type="button"
                  className={`admin-orgsel__item ${!active ? "is-active" : ""}`}
                  onClick={() => choose("")}
                  data-testid="admin-orgsel-item-global">GLOBAL (no scope)</button>
          {orgs.map((o) => (
            <button key={o.id || o._id}
                    type="button"
                    className={`admin-orgsel__item ${(o.id || o._id) === active ? "is-active" : ""}`}
                    onClick={() => choose(o.id || o._id)}
                    data-testid={`admin-orgsel-item-${(o.id || o._id).slice(0,8)}`}>
              {o.name} · <span className="admin-orgsel__tier">{(o.tier || "free").toUpperCase()}</span>
            </button>
          ))}
          {orgs.length === 0 && <div className="admin-foot-note" style={{ padding: 8 }}>No organizations yet.</div>}
        </div>
      )}
    </span>
  );
}
